import { createSlice } from '@reduxjs/toolkit';
import Reducers from '../../../_shared/constants/reducers';

const reduceShowFooter = (state, action) => {
  const temp = {
    ...state,
    ...action.payload
  };

  return {
    ...temp,
    showFooter: temp.isLastPageDecision && temp.isLastPageNegotiations
  };
};

const pendingStateSlice = createSlice({
  name: Reducers.PENDING_STATE,
  initialState: {
    showFooter: false,
    decisionPageNumber: 0,
    isLastPageDecision: false,
    negotiationPageNumber: 0,
    isLastPageNegotiations: false,
    tradeIdToRemove: undefined,
    tradeDetails: undefined
  },
  reducers: {
    changePageDecision: reduceShowFooter,
    changePageNegotiations: reduceShowFooter,
    removePendingTrade: (state, action) => ({
      ...state,
      tradeIdToRemove: action.payload
    }),
    addPendingTrade: (state, action) => ({
      ...state,
      tradeDetails: action.payload
    })
  }
});

export const {
  changePageDecision,
  changePageNegotiations,
  removePendingTrade,
  addPendingTrade
} = pendingStateSlice.actions;

export default pendingStateSlice.reducer;
